export default __webpack_public_path__ + "static/media/cash_payments.0c1a30db.svg";